import { createStore, type StoreApi } from 'zustand';

import type { SystemEnums } from '../types/SystemEnums';

export type SystemEnumsState = {
    systemEnums: SystemEnums | null;
};

export type SystemEnumsActions = {
    updateSystemEnums: (systemEnums: SystemEnumsState['systemEnums']) => void;
    resetStore: () => void;
};

export type SystemEnumsStore = SystemEnumsState & SystemEnumsActions;

export const initialState: SystemEnumsState = {
    systemEnums: null,
};

export function createSystemEnumsStore(systemEnumsState: SystemEnumsState = initialState): StoreApi<SystemEnumsStore> {
    return createStore<SystemEnumsStore>()((set) => ({
        ...systemEnumsState,
        updateSystemEnums: (systemEnums): void => {
            set(() => ({ systemEnums }));
        },
        resetStore: (): void => {
            set(initialState);
        },
    }));
}

